import React from "react";
import styled from "styled-components";

import RichContentTtsDisplay from "../../common/RichContentTtsDisplay";

const Styled = styled.div`
  line-height: 1.4em;

  img {
    max-width: 100%;
  }
`;

interface Props {
  data?: any;
}

const Prompt: React.FC<React.PropsWithChildren<Props>> = (props) => {
  return (
    <>
      {props.data && (
        <Styled className="item-player-prompt">
          <RichContentTtsDisplay content={props.data.body} />
        </Styled>
      )}
    </>
  );
};
export default Prompt;
